import { useLocation, useNavigate } from "react-router";
import { useOperationsContext } from "../../../../../context/OperationsContextProvider";
import Announcements from "./Announcements";
import FilterSidebar from "./FilterSidebar";
import { useEffect } from "react";

function AnnouncementsMain() {
  const {
    setShowAnnouncementViewModal,
    setSelectedAnnouncementId,
    announcementData,
    regulationData,
    announcementUrgentData,
  } = useOperationsContext();
  const { state } = useLocation();
  const navigate = useNavigate();
  const handleAnnouncementOpen = (announcementId: string) => {
    setSelectedAnnouncementId(announcementId);
    setShowAnnouncementViewModal(true);
    navigate("", { replace: true });
  };

  const hasData =
    announcementData?.length > 0 ||
    regulationData?.length > 0 ||
    announcementUrgentData?.length > 0;

  useEffect(() => {
    if (state?.announcementId) {
      handleAnnouncementOpen(state.announcementId);
    }
  }, [state, hasData]);

  return (
    <div className="w-full h-full">
      <div className="w-full h-full flex extraSmall:flex-col xl:flex-row">
        <FilterSidebar />

        <div className="flex-1 flex flex-col min-h-0">
          <Announcements />
        </div>
      </div>
    </div>
  );
}

export default AnnouncementsMain;
